import { EntityState } from '@ngrx/entity';
import { MessageData } from './models/message-data.model';
import { MessageConversation } from './models/message-conversation.model';
import { messageConversationEntityAdapter } from './adapters/message-conversation.adapter';
import { WrapUpsSubState } from '../common/models/wrap-up-sub-state.model';

export interface GenesysCloudMessagesSubState {
  [conversationId: string]: EntityState<MessageData>;
}
export type ConversationsSubState = EntityState<MessageConversation>;

export interface GenesysCloudMessageConversationsState {
  conversations: ConversationsSubState;
  messages: GenesysCloudMessagesSubState;
  wrapups: WrapUpsSubState;
}

export const initialConversationsSubState = (): ConversationsSubState => messageConversationEntityAdapter.getInitialState();
export const initialConversationMessagesSubState = (): GenesysCloudMessagesSubState => ({});
export const initialWrapUpsSubState = (): WrapUpsSubState => ({});

export const initialState = (): GenesysCloudMessageConversationsState => ({
  conversations: initialConversationsSubState(),
  messages: initialConversationMessagesSubState(),
  wrapups: initialWrapUpsSubState()
});
